import { jsxs, jsx } from "react/jsx-runtime";
import { Combobox, Icon } from "@zillow/constellation-10";
import { IconSearchFilled } from "@zillow/constellation-icons/react/filled/icon-search-filled";
import "react";
import { installations } from "./installations.json.esm.js";
const OPTIONS = installations;
const MilitaryInstallationSelector = ({
  onChange
}) => {
  const handleOptionSelect = (option) => {
    const label = typeof option === "string" ? option : option.label;
    typeof onChange === "function" && onChange(label);
  };
  return /* @__PURE__ */ jsxs(Combobox.Root, { appearance: "input", autoCompleteBehavior: "manual", onOptionSelect: handleOptionSelect, options: OPTIONS, placeholder: "Start typing installation name", showLabelForValue: true, size: "lg", children: [
    /* @__PURE__ */ jsx(Combobox.Trigger, { renderClear: () => null, css: {
      backgroundColor: "gray.50",
      minHeight: "69px",
      boxShadowColor: "border.muted",
      _hover: {
        backgroundColor: "gray.50",
        boxShadowColor: "border.accent.brand.hero"
      }
    }, renderInputGroup: ({
      children,
      ...inputGroupProps
    }) => /* @__PURE__ */ jsxs("div", { ...inputGroupProps, style: {
      display: "flex",
      alignItems: "center",
      flex: 1
    }, children: [
      children,
      /* @__PURE__ */ jsx(Icon, { render: /* @__PURE__ */ jsx(IconSearchFilled, {}), size: "md", css: {
        color: "icon.subtle",
        flexShrink: 0
      } })
    ] }), renderInput: (inputProps) => /* @__PURE__ */ jsx(Combobox.Input, { ...inputProps, css: {
      textStyle: "body-bold",
      paddingInlineStart: "tighter",
      _placeholder: {
        color: "text.subtle"
      }
    } }) }),
    /* @__PURE__ */ jsx(Combobox.Portal, { children: /* @__PURE__ */ jsx(Combobox.Content, {}) })
  ] });
};
export {
  MilitaryInstallationSelector as default
};
